export default __webpack_public_path__ + "static/media/Coil of the Cobra.9663fad5.jpg";